<template>
	<div class="select-card">
		<div v-if="header" class="select-card-title">
			<slot name="header">{{ header }}</slot>
		</div>
		<el-scrollbar>
			<slot></slot>
		</el-scrollbar>
	</div>
</template>
<script>
export default {
	name: 'select-card',
	props: {
		header: {
			type: [Boolean, String],
			default: true,
		},
	},
};
</script>
<style lang="scss">
.select-card {
	min-width: 250px;
	min-height: 280px;
	border: 1px solid #E4E7ED;
	border-radius: 4px;
	box-sizing: border-box;

	& + .select-card {
		margin-left: 18px;
	}

	.select-card-title {
		padding: 0 14px;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #E4E7ED;

		.el-link + .el-link {
			margin-left: 8px;
		}
	}

	.alert {
		margin: 10px 10px 0px;

		&:last-child {
			margin-bottom: 10px;
		}
	}
}
</style>
